export default __webpack_public_path__ + "static/media/like.cef865f4.svg";